import cn from 'classnames';
import { CustomTooltip } from '@src/components/tooltip/Tooltip';
import { andOrToggleClasses } from './styles';

export interface AndOrToggleProps {
  disabled?: boolean;
}

/**
 * LF360-1823: the And/Or segmented control (Figma node 14328:41254).
 *
 * The evaluator is AND-only, so "Or" renders as the design draws it - present
 * at 30% opacity and inert. Wiring it up needs a combinator field on the
 * behavior-rules schema plus backend evaluation support; explicitly out of
 * scope here.
 */
export const AndOrToggle = ({ disabled = false }: AndOrToggleProps) => {
  const classes = andOrToggleClasses();

  return (
    <div
      className={cn(classes.group, { 'opacity-50': disabled })}
      data-testid="info=>behavior:combinator"
    >
      <span className={classes.active}>And</span>
      <CustomTooltip content="Or is not supported yet - conditions are combined with And">
        <span className={classes.inactive} aria-disabled={true}>Or</span>
      </CustomTooltip>
    </div>
  );
};
